import React from 'react'

function ConsoleButton({ label, clickMessage, onClick }) {
  if (onClick) {
    return (
      <button onClick={onClick}>
        {label}
      </button>
    )
  } else {
    return (
      <button onClick={() => console.log(clickMessage)}>
        {label}
      </button>
    )
  }
}

export default ConsoleButton